import { useLocation } from 'react-router';
import _ from 'lodash';
import { PAT_ONLY_PROVIDERS } from 'common/constants/constants';
import QueryString from 'qs';
import PATLinkAccount from './PATLinkAccount';
import OAuthLinkAccount from './OAuthLinkAccount';

const LinkAccount = () => {
  const location = useLocation();
  const search = QueryString.parse(_.get(location, 'search'), {
    ignoreQueryPrefix: true
  });
  const providerName =
    _.get(search, 'providerName') || _.get(location, 'state.providerName', '');
  return Object.values(PAT_ONLY_PROVIDERS).includes(providerName) ? (
    <PATLinkAccount providerName={providerName} />
  ) : (
    <OAuthLinkAccount />
  );
};
export default LinkAccount;
